// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"IX-z","inlineTitle":"JX-z","sponsoredAdsWrapper":"KX-z","marketplaceRecosWrapper":"LX-z"};